import { tmxApiCall } from './index'

// Utilities
import Logger from '../utility/loggerUtil'

export default {
  /**
   * Gets all debit card types.
   * @returns {Promise<{cardTypes: {}, error: String}>} An object of card types.
   */
  async getDebitCardTypes () {
    Logger.info('Started Get Card Types query.')
    return tmxApiCall('get', '/cardtypes')
  },

  /**
   * Gets all debit cards associated with the customer and their processor types and any card validations.
   * @param {Number} paymentProcessorTypeEnum - The type of payment processor used by the customers loans.
   * @returns {Promise<{cards: [], validations: {}}>} An array of cards and object of validation properties.
   */
  async getDebitCards (paymentProcessorTypeEnum) {
    Logger.info('Started Get Card query.')
    return tmxApiCall('get', '/cards', {
      params: {
        payProviderType: paymentProcessorTypeEnum
      }
    })
  },

  /**
   * Adds a debit card to a customers list of debit cards saved with a payment processor.
   * @param {Boolean} guestCard - Flag if the card to add is a guest card.
   * @param {String} tokenPayTempToken - The BridgePay tokenized card.
   * @returns {Promise<{card: {cardIds: String, cardNumber: String, name: String, customerId: String, customerIds: [], guestCard: Boolean}}>} A debit card object.
   */
  async addDebitCard (guestCard, tokenPayTempToken) {
    Logger.info('Started Add Card query.')
    return tmxApiCall('post', '/cards', {
      guestCard,
      tokenPayTempToken
    })
  },

  async removeDebitCard (cardIds) {
    Logger.info('Started Remove Card query.')
    return tmxApiCall('put', '/cards', {
      cardIds
    })
  },

  /**
   * Creates a new card form key session for the client.
   * @param {String} transactionType - The type of transaction that the card will be used for (payment or debit).
   * @param {String} [origin] - Optional, include the origin if in a browser.
   * @returns {Promise<{acceptance: Object, acceptanceConfig: {formUrl: String}, key: Object}>} A form key data.
   */
  async getCardFormKey (transactionType, origin = undefined) {
    Logger.info('Getting card form key')
    return tmxApiCall('get', '/cardFormKey', {
      params: {
        cardTransactionType: transactionType,
        origin
      }
    })
  },

  /**
   * Checks card details to determine if the card is allowed to be added to the customer's account.
   * @param {String} cardBin - The first 8 digits of the card number.
   * @returns {Promise<{cardDetails: {cardAllowed: Boolean}}>} Whether the card is allowed to be added or not.
   */
  async cardLookup (cardBin) {
    Logger.info('Started Card Lookup query')

    return tmxApiCall('post', '/cardLookup', {
      cardBin: cardBin.substring(0, 8)
    })
  }
}
